export default "__VITE_ASSET__DdaPiKLC__"